import { render, staticRenderFns } from "./bonuses.vue?vue&type=template&id=022f531f&scoped=true&"
import script from "./bonuses.vue?vue&type=script&lang=js&"
export * from "./bonuses.vue?vue&type=script&lang=js&"
import style0 from "./bonuses.vue?vue&type=style&index=0&id=022f531f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f531f",
  null
  
)

export default component.exports